export default [
	{ value: 1, text: 'Goede weersomstandigheden' },
	{ value: 2, text: 'Goede weersomstandigheden - zeer zonnig' },
	{ value: 3, text: 'Regenachtig weer - geen beperking' },
	{ value: 4, text: 'Regenachtig weer matig beperkt' },
	{ value: 5, text: 'Zeer veel neerslag - geen beperking' },
]